import React from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import styles from './EditAntropometria.module.scss';
import { useConsulta } from '../contexts/ConsultaContext';
import FormLabel from './FormLabel';
import ImcResultado from './ImcResultado';
import BodyFatResultado from './BodyFatResultado';
import SkinfoldBodyFatResultado from './SkinfoldBodyFatResultado';
import Button from './Button';
import { fetchAuth } from '../utils/fetchAuth';


const EditAntropometria: React.FC = () => {
    const { consulta, setConsulta } = useConsulta();
    const [saving, setSaving] = React.useState(false);

    const modified = (() => {
        const edited = consulta?.avaliacao_antropometrica?.last_edited;
        const updated = consulta?.avaliacao_antropometrica?.last_updated;

        if (!edited || !updated) return false;

        return new Date(edited) > new Date(updated);
    })();

    return (
        <>
            <Container>
                <h5 className="mb-3">Avaliação Antropometrica</h5>
            </Container>
            <Container>
                <Row>
                    <Col>
                        <h6 className="mb-3">Dados Antropométricos</h6>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='peso'
                            >
                                Peso (kg):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='peso'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.peso || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.peso = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='altura'
                            >
                                Altura (m):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='altura'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.altura || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.altura = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {consulta?.avaliacao_antropometrica &&
                    (consulta?.avaliacao_antropometrica.peso ?? 0) > 0 && (consulta?.avaliacao_antropometrica.altura ?? 0) > 0 ?
                    (
                        <Row>
                            <Col>
                                <ImcResultado
                                    peso={consulta?.avaliacao_antropometrica?.peso || 0}
                                    altura={consulta?.avaliacao_antropometrica?.altura || 0}
                                />
                            </Col>
                        </Row>
                    ) : (<></>)}
                <Row>
                    <Col>
                        <h6 className="mb-3">Circunferências</h6>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='cintura'
                            >
                                Circunferencia da Cintura (cm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='cintura'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.circunferencia_cintura || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.circunferencia_cintura = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='quadril'
                            >
                                Circunferência do Quadril (cm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='quadril'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.circunferencia_quadril || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.circunferencia_quadril = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='pescoço'
                            >
                                Circunferência de Pescoço (cm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='pescoço'
                                step={0.01}
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.circunferencia_pescoco || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_edited: (new Date()).toISOString(),
                                            last_modified: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.circunferencia_pescoco = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {consulta?.avaliacao_antropometrica &&
                    consulta?.sexo && (consulta?.avaliacao_antropometrica.circunferencia_cintura ?? 0) > 0 && (consulta?.avaliacao_antropometrica.circunferencia_quadril ?? 0) > 0 && (consulta?.avaliacao_antropometrica.circunferencia_pescoco ?? 0) > 0 && (consulta?.avaliacao_antropometrica.altura ?? 0) > 0 ?
                    (
                        <Row>
                            <Col>
                                <BodyFatResultado
                                    sexo={consulta?.sexo}
                                    cinturaCm={consulta?.avaliacao_antropometrica.circunferencia_cintura || 0}
                                    quadrilCm={consulta?.avaliacao_antropometrica.circunferencia_quadril || 0}
                                    pescocoCm={consulta?.avaliacao_antropometrica.circunferencia_pescoco || 0}
                                    alturaCm={(consulta?.avaliacao_antropometrica.altura ?? 0) * 100}
                                />
                            </Col>
                        </Row>
                    ) : (<></>)}
                <Row>
                    <Col>
                        <h6 className="mb-3">Dobras cutâneas</h6>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='tricipital'
                            >
                                Dobra Cutânea Tricipital (mm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='tricipital'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.dobra_cutanea_tricipital || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.dobra_cutanea_tricipital = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='subescapular'
                            >
                                Dobra Cutânea do Abdobinal (mm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='subescapular'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.dobra_cutanea_subescapular || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.dobra_cutanea_subescapular = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='coxa'
                            >
                                Circunferência da Coxa (mm):
                            </FormLabel>
                            <Form.Control
                                type='number'
                                id='coxa'
                                className={styles['input-control']}
                                defaultValue={consulta?.avaliacao_antropometrica?.dobra_cutanea_coxa || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.avaliacao_antropometrica)
                                        updatedConsulta.avaliacao_antropometrica = {
                                            id: -1,
                                            last_updated: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.avaliacao_antropometrica.dobra_cutanea_coxa = parseFloat(e.target.value);
                                    updatedConsulta.avaliacao_antropometrica.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                step={0.01}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {consulta?.avaliacao_antropometrica &&
                    consulta?.sexo && (consulta?.avaliacao_antropometrica.dobra_cutanea_coxa ?? 0) > 0 && (consulta?.avaliacao_antropometrica.dobra_cutanea_subescapular ?? 0) > 0 && (consulta?.avaliacao_antropometrica.dobra_cutanea_tricipital ?? 0) > 0 ?
                    (
                        <Row>
                            <Col>
                                <SkinfoldBodyFatResultado
                                    sexo={consulta?.sexo}
                                    tricipitalMm={consulta?.avaliacao_antropometrica.dobra_cutanea_tricipital || 0}
                                    abdominalMm={consulta?.avaliacao_antropometrica.dobra_cutanea_subescapular || 0}
                                    coxaMm={consulta?.avaliacao_antropometrica.dobra_cutanea_coxa || 0}
                                />
                            </Col>
                        </Row>
                    ) : (<></>)}
                <Row>
                    <Col>
                        <Button
                            disabled={!modified || saving}
                            onClick={() => {
                                if (!consulta) return;
                                setSaving(true);
                                fetchAuth(`${process.env.REACT_APP_API_URL}/consultorio/consultations/${consulta.id}/avaliacao`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        weight: consulta?.avaliacao_antropometrica?.peso || 0,
                                        height: consulta?.avaliacao_antropometrica?.altura || 0,
                                        waistCircumference: consulta?.avaliacao_antropometrica?.circunferencia_cintura || 0,
                                        hipCircumference: consulta?.avaliacao_antropometrica?.circunferencia_quadril || 0,
                                        neckCircumference: consulta?.avaliacao_antropometrica?.circunferencia_pescoco || 0,
                                        skinfold1: consulta?.avaliacao_antropometrica?.dobra_cutanea_tricipital || 0,
                                        skinfold2: consulta?.avaliacao_antropometrica?.dobra_cutanea_subescapular || 0,
                                        skinfold3: consulta?.avaliacao_antropometrica?.dobra_cutanea_coxa || 0,
                                    }),
                                })
                                    .then(async (response) => {
                                        if (!response.ok) {
                                            const error_json = await response.json();
                                            throw new Error(error_json.message || 'Erro ao salvar avaliação antropométrica');
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        if (!consulta) return;
                                        setConsulta({
                                            ...consulta,
                                            avaliacao_antropometrica: {
                                                id: -1,
                                                peso: consulta.avaliacao_antropometrica?.peso || 0,
                                                altura: consulta.avaliacao_antropometrica?.altura || 0,
                                                circunferencia_cintura: consulta.avaliacao_antropometrica?.circunferencia_cintura || 0,
                                                circunferencia_quadril: consulta.avaliacao_antropometrica?.circunferencia_quadril || 0,
                                                circunferencia_pescoco: consulta.avaliacao_antropometrica?.circunferencia_pescoco || 0,
                                                dobra_cutanea_tricipital: consulta.avaliacao_antropometrica?.dobra_cutanea_tricipital || 0,
                                                dobra_cutanea_subescapular: consulta.avaliacao_antropometrica?.dobra_cutanea_subescapular || 0,
                                                dobra_cutanea_coxa: consulta.avaliacao_antropometrica?.dobra_cutanea_coxa || 0,
                                                last_edited: (new Date()).toISOString(),
                                                last_updated: (new Date()).toISOString(),
                                            },
                                        });

                                    })
                                    .catch(error => {
                                        console.error('Erro ao salvar:', error);
                                    })
                                    .finally(() => {
                                        setSaving(false);
                                    });

                            }}
                        >
                            {modified ? (saving ? 'Salvando' : 'Salvar') : 'Salvo'}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default EditAntropometria;
